@if (isUpdating$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}

<form  (ngSubmit)="onSubmit()"
  [formGroup]="form"
  [attr.method]="method"
  [attr.action]="action"
  #loginForm>
  <label>
    <span class="label-content">{{
      'loginForm.emailAddress.label' | cxTranslate
    }}</span>
    <input
      required="true"
      type="email"
      class="form-control"
      placeholder="{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}"
      [attr.aria-label]="'loginForm.emailAddress.label' | cxTranslate"
      formControlName="userId"
      name="username"
      [attr.aria-invalid]="
        form.get('userId')?.touched && form.get('userId')?.invalid
      "
      [attr.aria-errormessage]="'userIdError'"
      />
      <cx-form-errors [control]="form.get('userId')"></cx-form-errors>
    </label>

    <label>
      <span class="label-content">{{
        'loginForm.password.label' | cxTranslate
      }}</span>
      <input
       required="true"
      type="password"
      class="form-control"
      placeholder="{{ 'loginForm.password.placeholder' | cxTranslate }}"
      formControlName="password"
      name="password"
      [attr.aria-label]="'loginForm.password.placeholder' | cxTranslate"
      [attr.aria-invalid]="
        form.get('password')?.touched && form.get('password')?.invalid
      "
      [attr.aria-errormessage]="'passwordError'"
        />
        <cx-form-errors [control]="form.get('password')"></cx-form-errors>
      </label>

      <ng-container>
        <input type="hidden" name="_csrf" [value]="service.csrf?.token" />
      </ng-container>

      <a
        [routerLink]="{ cxRoute: 'forgotPassword' } | cxUrl"
        aria-controls="reset-password"
        class="btn-link"
        >{{ 'loginForm.forgotPassword' | cxTranslate }}</a
        >

        <button
          type="submit"
          class="btn btn-block btn-primary"
          [disabled]="form.disabled"
          >
          {{ 'loginForm.signIn' | cxTranslate }}
        </button>
      </form>
